export const TESTID = {
	INTERFACE: {
		SCROLL_VIEW: 'interface_scrollview',
		BACK_BUTTON: 'interface_back_button',
		
		CALENDAR: {
			SWITCH_MODE_BUTTON: 'interface_calendar_switch_mode_button',
			PREVIOUS_MONTH_BUTTON: 'interface_calendar_previous_month_button',
			NEXT_MONTH_BUTTON: 'interface_calendar_next_month_button',
			MONTH_LABEL: 'interface_calendar_month_label',
			PREVIOUS_WEEK_BUTTON: 'interface_calendar_previous_week_button',
			NEXT_WEEK_BUTTON: 'interface_calendar_next_week_button',
			WEEK_LABEL: 'interface_calendar_week_label',
			DAY_BUTTON: 'interface_calendar_day_button',
		},
		
		SPLASH_SCREEN: 'interface_splash_screen',
		
		LOADING_INDICATOR: {
			DEFAULT: 'interface_loading_indicator',
			LOGGING_IN: 'interface_loading_indicator_logging_in',
		}
	},
	
	AUTHENTICATION: {
		DOMAIN_INPUT: 'authentication_domain_input',
		DOMAIN_PREFIX_BUTTON: 'authentication_domain_prefix_button',
		EMAIL_INPUT: 'authentication_email_input',
		TOKEN_INPUT: 'authentication_token_input',
		TOKEN_SEND_BUTTON: 'authentication_token_send_button',
		WELCOME_VIEW: 'authentication_welcome_view',
	},
	
	HOME: {
		NAVIGATION: {
			HOME: 'home_navigation_home',
			BOOK: 'home_navigation_book',
			COWORKERS: 'home_navigation_coworkers',
			MORE: 'home_navigation_more',
		},
		
		EMPLOYEE_CARD: {
			EMPLOYEE_CARD_LOGGED_IN: 'employee_card_logged_in',
			EMPLOYEE_CARD: 'employee_card',
			HEART: 'employee_card_heart',
		},
		
		HOME: {
			SCREENS: {
				INDEX: 'home_screens_index',
			},
			INDEX: {
				WELCOME_GREETING_VIEW: 'home_home_index_welcome_greeting_view',
			}
		},
		
		BOOK: {
			SCREENS: {
				INDEX: 'home_book_screens_index',
			},
			START: {
				BOOK_ROOM_MYSELF_BUTTON: 'home_book_start_book_room_for_myself_button',
				BOOK_ROOM_MYSELF_AND_COWORKERS_BUTTON: 'home_book_start_book_room_for_myself_and_coworkers_button',
				BOOK_ROOM_COWORKERS_BUTTON: 'home_book_start_book_room_for_coworkers_button',
				BOOK_MEETING_ROOM_MYSELF_BUTTON:'home_book_start_book_meeting_room_for_myself_button',
				BOOK_MEETING_ROOM_MYSELF_AND_COWORKERS_BUTTON: 'home_book_start_book_meeting_room_for_myself_and_coworkers_button',
				BOOK_MEETING_ROOM_COWORKERS_BUTTON: 'home_book_start_book_meeting_room_for_coworkers_button',
				
				TIMESLOT_GROUP: {
					VIEW: 'book_timeslot_group_view',
					BOOK_OPTION: 'book_timeslot_group_book_option',
				},
			},
			COWORKER:{
				NAVIGATION: {
					FAVOURITES: 'home_book_coworker_navigation_favourites',
					COWORKERS: 'home_book_coworker_navigation_coworkers',
					EXTERNAL: 'home_book_coworker_navigation_external',
				},
				EMPLOYEE_LIST: {
					BLOCK: 'home_employee_list_block',
				},
				BOOKING_FOOTER: {
					COWORKER_COUNTER: 'home_book_coworker_booking_footer_coworker_counter',
					SUBMIT_BUTTON: 'SUBMIT_BUTTON'
				}
			},
			LOCATION: {
				LOCATION_ITEM: 'home_book_location_location_item',
			},
			BOOKING_FOOTER: {
				EXTENDING_FOOTER_COLLAPSED: 'home_book_booking_footer_extending_footer_collapsed',
				EXTENDING_FOOTER_EXTENDED: 'home_book_booking_footer_extending_footer_extended',
				EXTENDING_FOOTER_TIMESLOT: 'home_book_booking_footer_extending_footer_timeslot',
				SUFFIX_EXTENDING_FOOTER_CLOSE_BUTTON: 'close_button',
				SUFFIX_EXTENDING_FOOTER_SUBMIT_BUTTON: 'submit_button',
				WORKPLACE_COUNTER: 'home_book_booking_footer_workplace_counter',
				LUNCH_COUNTER: 'home_book_booking_footer_lunch_counter',
				PARKING_COUNTER: 'home_book_booking_footer_parking_counter',
				MEETINGROOM_COUNTER: 'home_book_booking_footer_meetingroom_counter',
				SUBMIT_BUTTON: 'home_book_booking_footer_submit_button',
			},
			EMPLOYEE_FOOTER: {
				EXTENDING_FOOTER_COLLAPSED: 'home_book_employee_footer_extending_footer_collapsed',
				EXTENDING_FOOTER_EXTENDED: 'home_book_employee_footer_extending_footer_extended',
				EXTENDING_FOOTER_EMPLOYEE: 'home_book_employee_footer_extending_footer_employee',
				SUFFIX_EXTENDING_FOOTER_CLOSE_BUTTON: 'close_button',
				SUFFIX_EXTENDING_FOOTER_SUBMIT_BUTTON: 'submit_button',
			},
			TIMESLOTS: {
				TIMESLOT: 'home_book_timeslots_timeslot',
				SUFFIX_QRCODE_BUTTON: 'qrcode_button',
				SUFFIX_DELETE_BUTTON: 'delete_button'
			},
			LICENSE_PLATE: {
				DEFAULT_LICENSE_PLATE_INPUT: 'home_book_license_plate_default_license_plate_input',
				SINGLE_LICENSE_PLATE_INPUT: 'home_book_license_plate_single_license_plate_input'
			},
			VALIDATE: {
				LOADING_MODAL: 'home_book_validate_loading_modal'
			},
			FINISHED: {
				DONE_BUTTON: 'home_book_finished_done_button',
			}
		},
		
		COWORKER: {
			SCREENS: {
				INDEX: 'home_coworker_screen_index'
			},
			
			NAVIGATION: {
				FAVOURITES: 'home_coworker_navigation_favourites',
				EROS: 'home_coworker_navigation_eros',
				CONFIDANT: 'home_coworker_navigation_confidant',
				SEARCH: 'home_coworker_navigation_search',
			},
			
			FAVOURITES: {
				NO_RESULTS_VIEW: 'home_coworker_favourites_no_results_view',
			},
			
			SEARCH: {
				SEARCH_INPUT: 'home_coworker_search_search_input',
				SEARCH_CHECKBOX: 'home_coworker_search_search_checkbox',
				SHOW_RESULTS_BUTTON: 'home_coworker_search_show_results_button',
				TOO_MANY_RESULTS_BUTTON: 'home_coworker_search_too_many_results_button',
				RESET_BUTTON: 'home_coworker_search_reset_button',
				NO_FILTERS_BUTTON: 'home_coworker_search_no_filters_button'
			}
		},
		MORE: {
			SCREENS: {
				INDEX: 'home_more_screen_index',
				PROFILE: 'home_more_screen_profile',
				WORKDAYS: 'home_more_screen_workdays',
				PRIVACY: 'home_more_screen_privacy',
				INBOX: 'home_more_screen_inbox',
				SETTINGS: 'home_more_screen_settings',
				CALENDAR_SUBSCRIPTION: 'home_more_screen_calendar_subscription',
				ABOUT: 'home_more_screen_about',
			},
			INDEX: {
				BUTTONS_VIEW: 'home_more_index_buttons_view',
				PROFILE_BUTTON: 'home_more_index_profile_button',
				WORKDAYS_BUTTON: 'home_more_index_workdays_button',
				PRIVACY_BUTTON: 'home_more_index_privacy_button',
				INBOX_BUTTON: 'home_more_index_inbox_button',
				SETTINGS_BUTTON: 'home_more_index_settings_button',
				CALENDAR_SUBSCRIPTION_BUTTON: 'home_more_index_calendar_subscription_button',
				ABOUT_BUTTON: 'home_more_index_about_button',
				LOGOUT_BUTTON: 'home_more_index_logout_button',
			},
			PROFILE: {
				FORM_PROFILE_VIEW: 'home_more_profile_form_profile_view',
				FORM_SUBMIT_BUTTON: 'home_more_profile_form_submit_button',
				NAME_INPUT: 'home_more_profile_name_input',
				PHONENUMBER_INPUT: 'home_more_profile_phonenumber_input',
				LANDLINE_PHONENUMBER_INPUT: 'home_more_profile_landline_phonenumber_input',
				LICENSE_PLATE_INPUT: 'home_more_profile_license_plate_input',
				ACCESS_CARD_ID_INPUT: 'home_more_profile_access_card_id_input',
			},
			WORKDAYS: {
				VIEW: 'home_more_workdays_view',
				OUTOFOFFICE_TOGGLE: 'home_more_workdays_outofoffice_toggle',
				WORKINGDAYS_VIEW: 'home_more_workdays_workingdays_view',
				SUBMIT_BUTTON: 'home_more_workdays_submit_button',
				DAY_COMPONENT: 'home_more_workdays_day_component',
				DAY_COMPONENT_TIME_START: 'home_more_workdays_day_component_time_start',
				DAY_COMPONENT_TIME_END: 'home_more_workdays_day_component_time_end',
			}
		}
	}
}